import React, { useState } from 'react';
import { Modal, Box, TextField } from '@mui/material';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  maxWidth: 400,
  width: '88%',
  bgcolor: 'background.paper',
  borderRadius: 'var(--r-xl)',
  boxShadow: 'var(--soft-shadow-lg)',
  p: 3,
};

const SoloSettingsModal = ({ open, handleClose, defaultPoolSize, defaultWindowSize, handleUpdate }) => {
  const [poolSize, setPoolSize] = useState(defaultPoolSize);
  const [windowSize, setWindowSize] = useState(defaultWindowSize);

  const handleSave = () => {
    handleUpdate(poolSize, windowSize);
    handleClose();
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
    >
      <Box sx={style} className="sg-modal-paper sg-anim-pop">
        <div className="sg-kicker" style={{ marginBottom: 4 }}>Just you</div>
        <h2 style={{ fontSize: '1.7rem', margin: '0 0 18px' }}>
          Solo settings
        </h2>
        <TextField
          margin="normal"
          fullWidth
          label="Letter pool size"
          helperText="How many letters are in play for the whole round."
          value={poolSize}
          onChange={(e) => setPoolSize(e.target.value)}
        />
        <TextField
          margin="normal"
          fullWidth
          label="Letter window size"
          helperText="How many of those letters you can see and pick from at once."
          value={windowSize}
          onChange={(e) => setWindowSize(e.target.value)}
        />
        <button
          type="button"
          className="sg-btn sg-btn--primary sg-btn--block"
          onClick={handleSave}
          style={{ marginTop: 20 }}
        >
          Update
        </button>
      </Box>
    </Modal>
  );
};

export default SoloSettingsModal;
